import React from 'react'
import './PrivacyPolicy.css'

const PrivacyPolicy = () => {
  return (
    <div className='privacypolicy container'>
        <h1 style={{padding:'150px 0 30px 0',textAlign:'center'}}>Privacy Policy</h1>
        <h4>About Artical Art : </h4><br/>
            <p>
            Artical Art is an Interior Design Company, based in Mumbai, India. It offers interior design services through its website (www.articalart.com) also we provide service in Pan India.
            </p>
        <h4>Your Privacy Matters to Us:</h4><br/>
            <p>
                At Artical Art, we take your privacy seriously. This policy explains how we collect, use, share, and protect your personal data when you use our website.
            </p>
            <p>
                By using our platform, you agree to the terms in this policy and give us permission to use your information as described.
            </p>
    
        <hr/>
        <h4>1.consent</h4><br/>
            <p>
                By accessing our site, you allow us and our trusted partners to contact you via phone, email, WhatsApp, SMS, or other channels to inform you about services, offers, or additional products. If you don’t agree, please don’t use our platform.
            </p>
        <hr/>

        <h4>2. What’s Covered in This Policy?</h4><br/>
            <ul>
                <li>How we collect and use your personal information (like your name, contact details, etc.)</li>
                <li>How we protect your information</li>
                <li>When we might share your data with others</li>
            </ul>
        <hr/>

        <h4>3. What Information We Collect:</h4><br/>
            <ul>
                <li><b>Personal Info: </b>Name, email, phone number, address, and preferences you share during registration or while using our services.</li>
                <li><b>Usage Data:</b>Pages visited, time spent, and device/browser info.</li>
                <li><b>Anonymous Data: </b>Info like IP address, cookies, browser type – used to improve our services.</li>
            </ul>   
            <p>
                We may also collect feedback or survey responses to enhance our services.
            </p>
        <hr/>
        <h4>4. Who Collects This Information?</h4><br/>
            <p>
                Artical Art collects data directly during account creation, contests, surveys, etc. Some anonymous data is also collected automatically when you use our site.

              We do not knowingly collect information from anyone under the age of 18.


            </p>
        <hr/>
        <h4>5. How We Use Your Data:</h4><br/>
            <ul>
                <li>To provide and improve our services</li>
                <li>To process your orders or requests</li>
                <li>To communicate with you about your account or offers</li>
                <li>To understand usage patterns and improve our platform</li>
                <li>For promotional campaigns (if you’ve agreed)</li>
            </ul>
            
            <p>Sometimes, we may share aggregate, non-personal info with third parties for analysis, but this won’t identify you.</p>
        <hr/>

        <h4>6. Sharing Your Information</h4><br/>
            <p>We do not sell or rent your personal info unless:</p>
            <ul>
                <li>You give permission</li>
                <li>It’s needed to provide the services you’ve requested</li>
                <li>Required by law or legal process</li>
                <li>To protect someone’s safety or enforce policies</li>
            </ul>
            <p>In case of a business merger or sale, we will inform you before your data is shared under new terms.</p>
        <hr/>

        <h4>7. Third-Party Links</h4><br/>
            <p>
                Our site may have links to other websites. We’re not responsible for how those sites handle your information. Please check their privacy policies separately.
            </p>
        <hr/>

        <h4>8. How We Protect Your Info</h4><br/>
            <p>
                We use various security measures (like restricted access, internal checks, etc.) to protect your data. However, no system is 100% secure, especially over the internet.
                Be cautious about what you share in public sections of the platform.
            </p>
        <hr/>

        <h4>9. Your Rights & Choices</h4><br/>
            <ul>
                <li>You can opt out of promotional emails by updating your preferences.</li>
                <li>You can also withdraw consent entirely by emailing us at support@articalart.com (Note: This may affect the services we can offer you).</li>

            </ul>
        <hr/>

        <h4>10. Policy Updates</h4><br/>
            <p>
                We may update this policy to meet legal or business needs. If we do, we’ll notify you as needed.
            </p>
            <hr/>
          
        <h4>11. Governing Law</h4><br/>
            <p>
                This policy is governed by Indian law, and any legal matters will be handled in courts located in Mumbai, India
            </p>
       
    </div>
  )
}

export default PrivacyPolicy